var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-content fs-14"},_vm._l((_vm.navList),function(item,index){return _c('div',{key:index,staticClass:"nav-item-content pointer",class:{ 'active-nav-item': _vm.selectIndex === item.index },on:{"click":function($event){return _vm.handleNavClick(item)}}},[_c('span',[_vm._v(_vm._s(item.title))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }